// extracted by mini-css-extract-plugin
module.exports = {"Sidebar":"Sidebar_Sidebar__g_fOP","Logo":"Sidebar_Logo__1ak0g","Menu":"Sidebar_Menu__xZLc6","Active":"Sidebar_Active__2-g69","Text":"Sidebar_Text__dJgbb"};